module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABaUlEQVQ4jaWTQWrCQBiFP0sijQERxazUraAVsitWvEHB3qRn6QVKt4UubKEnsNDgwoUQ11K7EEUQQS1m0fIPTcgkdiF9EIa8mXnz/jf/ZPr9/jcxZLNZcrkc6/U6TuM4juIOh4PGG/GfQqFAuVymUqng+762sN1uM5lMWC6XmrgmUKvVKJVKykG9XicJEbYs62+B8XisrLquy2q10rYXi0XlarFYaPxZ6pgT8W+BqAQJsNVqYRgGpmmqLJJoNpsqm8FgkBaQYGRCMpCFs9mM3W6n5iRUER4Oh2y32+MObNtWDvL5PEEQUK1WVeKC/X6vxk6nw2azYTQaRf0QCYjyfD7H87xIvdFoqFHuP4Q4jDeTdo2Cbrebqj3OSWlHSxBMp1P1nYKUg19Ieu9yIJCRJgUuJc/kwqTAG3AHvAD6q4FzoAfcytMIybCRPoBrKRd4OrJZ8AU8AlfADfAZCtwDF8DrCaU/S18BDz/2/nTODDIkhQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/foundNo.png
// module id = 0kOo
// module chunks = 102